import React from "react";
import ProductPage from "./ProductPage";
import image from "../Images/product-heroes/payroll-hero.png";
import detailImage from "../Images/dashboards/employee-dashboard.png";

const product = {
  "id": "payroll",
  "title": "Payroll Management",
  "headline": "Less payroll admin.",
  "accent": "More peace of mind.",
  "description": "Connect salary calculations, attendance, deductions and payslips in one payroll workflow. Keep your HR and finance teams aligned across multiple firms.",
  "checks": [
    "Flexible salary structures",
    "Attendance-linked payroll",
    "Employee payslips"
  ],
  "badge": "Payroll and workforce, connected",
  "imageAlt": "Illustration of a finance professional managing salary payments and payslips",
  "summary": [
    {
      "icon": "wallet",
      "title": "Organized salary processing",
      "text": "Bring calculations and deductions together."
    },
    {
      "icon": "calendar",
      "title": "Connected attendance",
      "text": "Use attendance and leave data in payroll."
    },
    {
      "icon": "file",
      "title": "Clear payroll records",
      "text": "Keep payslips and reports accessible."
    }
  ],
  "featuresTitle": "A simpler payroll cycle, from start to finish",
  "featuresSubtitle": "Keep the details organized so your team can focus on the next step.",
  "features": [
    {
      "title": "Salary calculations",
      "icon": "wallet",
      "text": "Manage salary components in a connected payroll process.",
      "points": [
        "Flexible salary structures",
        "Overtime and bonus calculations",
        "Attendance and leave inputs"
      ]
    },
    {
      "title": "Deductions & statutory reports",
      "icon": "file",
      "text": "Organize tax and contribution information for payroll review.",
      "points": [
        "PF, ESI and TDS records",
        "Deduction calculations",
        "Payroll reporting"
      ]
    },
    {
      "title": "Pay schedules & disbursement",
      "icon": "clock",
      "text": "Align payroll cycles with the way your organization works.",
      "points": [
        "Configurable pay periods",
        "Multiple payroll schedules",
        "Bank payment integration"
      ]
    },
    {
      "title": "Attendance integration",
      "icon": "calendar",
      "text": "Bring attendance and leave records into salary processing.",
      "points": [
        "Attendance data synchronization",
        "Shift and leave inputs",
        "Connected workforce records"
      ]
    },
    {
      "title": "Employee self-service",
      "icon": "people",
      "text": "Help employees find salary information without repeated requests.",
      "points": [
        "Downloadable payslips",
        "Salary and deduction details",
        "Reimbursement visibility"
      ]
    },
    {
      "title": "Reporting & access controls",
      "icon": "shield",
      "text": "Give your finance team a clear view of payroll activity.",
      "points": [
        "Payroll expense reports",
        "Role-based permissions",
        "Reports for review and sharing"
      ]
    }
  ],
  "detailImageAlt": "BillPunch employee dashboard with payroll information and payslip access",
  "detailLabel": "Clarity for Every Employee",
  "detailTitle": "Payroll information, within reach.",
  "detailText": "Make salary records easier to find. Employee self-service connects payslips, deduction information and reimbursement requests with your everyday HR workflow.",
  "detailPoints": [
    "Access and download payslips",
    "Review salary and deduction records",
    "Track reimbursement requests"
  ],
  "workflowTitle": "Bring structure to every pay cycle",
  "steps": [
    [
      "Configure your payroll",
      "Set salary structures, deductions and pay periods."
    ],
    [
      "Connect workforce data",
      "Bring in attendance, leave and employee records."
    ],
    [
      "Review and process",
      "Review calculations before salary disbursement."
    ],
    [
      "Share and report",
      "Make payslips available and review payroll reports."
    ]
  ],
  "cta": "Make your next payroll cycle simpler."
};
product.image = image;
product.detailImage = detailImage;

const Payroll = () => <ProductPage product={product} />;

export default Payroll;
